import * as React from 'react';
import { Box, Container, Typography } from '@mui/material';
import CookieConsent from "react-cookie-consent";
import { HashLink } from 'react-router-hash-link';

export default function Footer() {
    return (
        <Box className="Footer">
            <Container maxWidth="lg" className="container FooterContainer">

                <Box className="FooterLeft">
                    <img src="HT-Logo-white.png" className='brandLogoFooter' />
                    <Typography variant='body1' paragraph className='whiteText'>
                    Harbecke & Thelen Notare<br />
                    Holzgasse 29 - 33<br />
                    Siegburg 53721<br />
                                                            </Typography>
                </Box>

                <Box className="FooterRight">      
                <HashLink className='FooterLink' style={{ textDecoration: 'none' }} smooth to="/Datenschutz#">Datenschutzrichtlinien</HashLink>
                <HashLink className='FooterLink' style={{ textDecoration: 'none' }} smooth to="/Impressum#">Impressum</HashLink>        
                </Box>
                
            </Container>

            <CookieConsent
                location="bottom"
                buttonText="Verstanden"
                cookieName="myAwesomeCookieName2"
                style={{ background: "#191c1f" }}
                buttonStyle={{ color: "#191c1f", fontSize: "20px", backgroundColor: "#FFFFFF" }}
                expires={170}
            >
                <Typography variant='body1' className='whiteText'>Diese Website verwendet nur technisch notwendige Cookies, um die Funktionalität zu gewährleisten. Es werden keine persönlichen Daten gesammelt.{" "}</Typography> 
            </CookieConsent>

        </Box>
    );
}